export const getLowHigh = (min, max, value) => {
  const data = {
    isLow: false,
    isHigh: false,
  };

  const nMin = parseFloat(min, 10);
  const nMax = parseFloat(max, 10);
  const nValue = parseFloat(value, 10);

  if (!isNaN(nMin) && !isNaN(nValue) && nMin > value) data.isLow = true;
  if (!isNaN(nMax) && !isNaN(nValue) && nMax < value) data.isHigh = true;
  return data;
};

